<template>
  <nav id="sidebar" aria-label="Main Navigation">
    <!-- Side Header -->
    <div class="bg-header-dark">
      <div class="content-header bg-white-10">
        <!-- Logo -->
        <router-link :to="{ name: 'dashboard' }">
          <detective-logo size="35px" color="#D18237" />
        </router-link>
        <router-link :to="{ name: 'dashboard' }" class="link-fx font-w600 font-size-lg text-white">
          <span class="text-white-75 text-uppercase">{{$t('layout.sideBar.' + selectedChain)}}</span>
          <span class="text-white">{{$t('layout.sideBar.detective')}}</span>
        </router-link>
        <!-- END Logo -->

        <!-- Options -->
        <div>
          <!-- Close Sidebar, Visible only on mobile screens -->
          <a @click="toggleSidebar" class="d-lg-none text-white ml-2" href="javascript:void(0)">
            <i class="fa fa-times-circle"></i>
          </a>
          <!-- END Close Sidebar -->
        </div>
        <!-- END Options -->
      </div>
    </div>
    <!-- END Side Header -->

    <!-- Side Auth User -->
    <div v-if="false" class="content-side content-side-full text-center bg-black-10">
      <div class="smini-hide">
        <router-link :to="{ name: 'profile' }" class="img-link d-block mb-3">
          <img
            class="img-avatar img-avatar-thumb"
            :src="getUserAvatar"
            :alt="$t('layout.sideBar.userAvatar')"
          />
        </router-link>
        <div v-text="displayName" class="mt-2 mb-1 font-w600"></div>
        <sidebar-user-link :title="$t('layout.sideBar.yourProfile')" icon="user" route="profile" />
        <sidebar-user-link :title="$t('layout.sideBar.settings')" icon="cog" route="settings" />
        <button
          v-b-tooltip.hover
          :title="$t('layout.sideBar.logout')"
          @click="logout"
          class="btn text-white-50"
        >
          <i class="fa fa-fw fa-sign-out-alt"></i>
        </button>
      </div>
    </div>
    <!-- END Side Auth User -->

    <!-- Side WAX Branding -->
    <div
      v-if="selectedChain === 'wax'"
      class="content-side content-side-full text-center bg-black-10"
    >
      <div class="smini-hide">
        <a href="https://wax.io" class="img-link d-block mb-3">
          <img class="img-avatar" src="@/assets/_img/wax-logo.webp" alt="WAX Mainnet" />
        </a>
        <a
          href="https://wax.io"
          class="mt-2 mb-1 font-w600"
        >Learn more about WAX Blockchain on WAX.io</a>
      </div>
    </div>
    <!-- END Side Auth User -->

    <!-- Side Navigation -->
    <div class="content-side content-side-full">
      <ul class="nav-main">
        <li class="nav-main-heading pt-0">{{$t('layout.sideBar.home')}}</li>
        <sidebar-link :title="$t('layout.sideBar.dashboard')" icon="home" route="dashboard" />
        <li
          v-if="currentUser.userTier >= 3"
          class="nav-main-heading"
        >{{$t('layout.sideBar.account')}}</li>
        <sidebar-link
          v-if="currentUser.userTier >= 3"
          :title="$t('layout.sideBar.profileScore')"
          icon="medal"
          route="AccountProfileHome"
        />
        <li class="nav-main-heading">{{$t('layout.sideBar.networkGraph')}}</li>
        <sidebar-link
          :title="$t('layout.sideBar.transfers')"
          icon="exchange-alt"
          route="NetworkGraphHome"
        />
      </ul>
    </div>
    <!-- END Side Navigation -->
  </nav>
</template>

<script>
import { mapMutations } from 'vuex'
import DetectiveLogo from '@/components/layout/detectiveLogo'
import SidebarLink from '@/components/common/SidebarLink'
import SidebarUserLink from '@/components/common/SidebarUserLink'
const fb = require('@/firebaseConfig.js')

export default {
  name: 'sideBar',
  components: {
    DetectiveLogo,
    SidebarLink,
    SidebarUserLink
  },
  computed: {
    selectedLanguage () {
      return this.$store.state.options.selectedLanguage
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    },
    displayName () {
      return this.$store.getters.displayName
    },
    getUserAvatar () {
      return this.$store.getters.getUserAvatar
    },
    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    ...mapMutations(['toggleSidebar', 'resetUser']),
    logout: function () {
      fb.auth.signOut().then(() => {
        this.resetUser()
        this.$router.replace('/')
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
